import React from 'react';
import PropTypes from 'prop-types';
import {
	Select,
	FormControl,
	InputLabel,
	FormHelperText,
} from '@material-ui/core/';
import { startCase } from 'lodash';

const BasicDropDown = (props) => {
	const { errorMessage, name, label, value, onChange, options } = props;
	
	const genKey = () => {
		const pre = Math.random().toString(36).substr(2, 5);
		
		return pre + new Date().getTime();
	}
	return (
		<FormControl fullWidth variant="outlined" error={!!errorMessage}>
			<InputLabel>{label || startCase(name)}</InputLabel>
			<Select
				name={name}
				label={label || startCase(name)}
				native
				fullWidth
				value={value}
				variant="outlined"
				onChange={onChange}
			>
				<option value=' ' disabled hidden>Choose here</option>
				{options.map((option, index) => (
					<option key={`${name}_option_${index}_${genKey()}`} value={option.value}>
						{option.displayText || startCase(option.value)}
					</option>
				))}
			</Select>
			<FormHelperText>{errorMessage}</FormHelperText>
		</FormControl>
	);
};
BasicDropDown.propType = {
	errorMessage: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onChange: PropTypes.func.isRequired,
	options: PropTypes.objectOf(
		PropTypes.shape({
			displayText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		})
	),
};

export default BasicDropDown;
